import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../../environments/environment';

export const SCREENING_REPORT_LINK = '/screening-report';

export const canViewScreeningReport = (msal: MsalService,
  allowedUserIds: string[] | null = (environment as { screeningReportAllowedUserIds?: string[] }).screeningReportAllowedUserIds ?? null): boolean => {
  if (allowedUserIds === null) {
    return true;
  }
  const account = msal.instance.getActiveAccount() ?? msal.instance.getAllAccounts()[0];
  return !!account && allowedUserIds.includes(account.localAccountId);
};

export const screeningReportAccessGuard: CanActivateFn = () =>
  canViewScreeningReport(inject(MsalService)) || inject(Router).parseUrl('/dashboard');
